var _rect, _path, _path2, _path3, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F9FAFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21.8334C21.4602 21.8334 21.8333 21.4603 21.8333 21.0001C21.8333 20.5398 21.4602 20.1667 21 20.1667C20.5397 20.1667 20.1666 20.5398 20.1666 21.0001C20.1666 21.4603 20.5397 21.8334 21 21.8334Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8333 21.8334C27.2935 21.8334 27.6666 21.4603 27.6666 21.0001C27.6666 20.5398 27.2935 20.1667 26.8333 20.1667C26.3731 20.1667 26 20.5398 26 21.0001C26 21.4603 26.3731 21.8334 26.8333 21.8334Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1666 21.8334C15.6269 21.8334 16 21.4603 16 21.0001C16 20.5398 15.6269 20.1667 15.1666 20.1667C14.7064 20.1667 14.3333 20.5398 14.3333 21.0001C14.3333 21.4603 14.7064 21.8334 15.1666 21.8334Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#D0D5DD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1 3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuButton);
export default __webpack_public_path__ + "static/media/menu-button.219d65fad44a57f4737f6ae835840ef1.svg";
export { ForwardRef as ReactComponent };